"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ARTICLE_DATA_FETCHING_RUNTIME_MAIN_KEY = exports.NUM_ARTICLES_FETCHED_KEY = exports.ORDER_SIDEBAR_TABS = exports.ORDER_TABS = exports.OUTSETA_STAGES = exports.BULL_MQ_KEEP_JOBS_VALUES_TEST = exports.BULL_MQ_KEEP_JOBS_VALUES = exports.sorceryBulkSettings = exports.sorceryBulkSettingsPriceMap = exports.gundamBulkSettings = exports.gundamBulkSettingsPriceMap = exports.cyberpunkBulkSettings = exports.cyberpunkBulkSettingsPriceMap = exports.riftboundBulkSettings = exports.riftboundBulkSettingsPriceMap = exports.swuBulkSettings = exports.swuBulkSettingsPriceMap = exports.bssBulkSettings = exports.bssBulkSettingsPriceMap = exports.lorcanaBulkSettings = exports.lorcanaBulkSettingsPriceMap = exports.onePieceBulkSettings = exports.onePieceBulkSettingsPriceMap = exports.digimonBulkSettings = exports.digimonBulkSettingsPriceMap = exports.FABBulkSettings = exports.FABBulkSettingsPriceMap = exports.WSBulkSettings = exports.WSBulkSettingsPriceMap = exports.FFBulkSettings = exports.FFBulkSettingsPriceMap = exports.DBSBulkSettings = exports.DBSBulkSettingsPriceMap = exports.vanguardBulkSettings = exports.vanguardBulkSettingsPriceMap = exports.pokemonBulkSettings = exports.pokemonBulkSettingsPriceMap = exports.yugiohBulkSettings = exports.yugiohBulkSettingsPriceMap = exports.magicBulkSettings = exports.magicBulkSettingsPriceMap = exports.TAXATION_RELEASE_DATE = exports.DAYS_BEFORE_RENEWAL = exports.SUBSCRIPTION_TIERS_NAMES = exports.SUBSCRIPTION_TIERS = exports.DEFAULT_PRICING_STRATEGY_IDS = exports.DEFAULT_COMPETITOR_IDS = exports.INVALID_PRICE = exports.DATA_PREPARATION_ERROR = exports.FULL_FETCH_STALENESS_DAYS = void 0;
exports.PRICE_CHANGE_TOO_SMALL = exports.SPLITTING_STRATEGY_CONVERSIONS = exports.SPLITTING_STRATEGY = exports.TAXATION_SCHEME_CONVERSIONS = exports.TAXATION_SCHEME_LABELS = exports.TAXATION_SCHEME = exports.TAXATION_ICON_VISIBILITY = exports.PURCHASE_EVENTS_STORE_SIZE = exports.GRADING_COMPANY_LABELS = exports.PICKING_SORTING_FIELDS = exports.PRICING_BOT_SOURCE = exports.countryEditionMap = exports.COUNTRY_EDITION = exports.FINISH_ATTRIBUTES = exports.FINISH_TYPES_CONVERSIONS = exports.FINISH_TYPE_LABELS = exports.FINISH_TYPES = exports.CountryEdition = exports.CONDITIONS_MAP_WITH_LABELS = exports.flagCode = exports.CARD_LANGUAGES_WITH_FLAGS = exports.INVENTORY_MULTI_SELECTION_UPDATES = exports.INVENTORY_TRANSACTION_SOURCES = exports.INVENTORY_TRANSACTION_CAUSES = exports.INVENTORY_TRANSACTION_TYPE = exports.ONBOARDING_SOURCE_SYNC = exports.INVENTORY_ZOOM_LEVELS = exports.ONBOARDING_STEPS = exports.INVENTORY_STEPS = exports.PRICING_DEFAULTS = exports.VIDEO_TUTORIALS = exports.TimePreset = exports.ARTICLE_STATES = exports.ORDER_PROPS = exports.ORDER_STATES = exports.ORDER_FILTERS = exports.FETCHING_JOURNAL_KEY = exports.NUM_429_ERRORS_KEY = exports.NUM_OLD_ARTICLES_KEY = exports.ARTICLE_DATA_FETCHING_RUNTIME_FAST_KEY = void 0;
var types_1 = require("./types");
exports.FULL_FETCH_STALENESS_DAYS = 3;
exports.DATA_PREPARATION_ERROR = 'Data preparation error';
exports.INVALID_PRICE = 'Invalid price';
// Ids of the competitors and pricing strategies that are pre-seeded by the User schema
// (backend/src/models/User/User.ts). Used to detect whether the user has created custom
// entries — if every entry's id is in here, the user hasn't customized anything yet.
exports.DEFAULT_COMPETITOR_IDS = ['321', '3210'];
exports.DEFAULT_PRICING_STRATEGY_IDS = ['1234', '1235', '4321'];
exports.SUBSCRIPTION_TIERS = [
    { id: types_1.OutsetaSubscriptionId.Vacation, cost: 0, min: Infinity, max: -Infinity },
    { id: types_1.OutsetaSubscriptionId.Collector, cost: 3, min: 0, max: 100 },
    { id: types_1.OutsetaSubscriptionId.Starter, cost: 10, min: 100, max: 300 },
    { id: types_1.OutsetaSubscriptionId.Trader, cost: 20, min: 300, max: 600 },
    { id: types_1.OutsetaSubscriptionId.Professional, cost: 40, min: 600, max: 1200 },
    { id: types_1.OutsetaSubscriptionId.Shop, cost: 60, min: 1200, max: 2500 },
    { id: types_1.OutsetaSubscriptionId.Powerseller, cost: 80, min: 2500, max: Infinity },
];
exports.SUBSCRIPTION_TIERS_NAMES = (_a = {},
    _a[types_1.OutsetaSubscriptionId.Vacation] = 'Vacation',
    _a[types_1.OutsetaSubscriptionId.Collector] = 'Collector',
    _a[types_1.OutsetaSubscriptionId.Starter] = 'Starter',
    _a[types_1.OutsetaSubscriptionId.Trader] = 'Trader',
    _a[types_1.OutsetaSubscriptionId.Professional] = 'Professional',
    _a[types_1.OutsetaSubscriptionId.Shop] = 'Shop',
    _a[types_1.OutsetaSubscriptionId.Powerseller] = 'Powerseller',
    _a);
exports.DAYS_BEFORE_RENEWAL = 5 * 24 * 60 * 60 * 1000;
// Taxation feature release date. Before this date no sales were recorded,
// so any taxation-related computation that depends on historical data
// must start from this date.
exports.TAXATION_RELEASE_DATE = new Date('2025-04-22T00:00:00.000Z');
exports.magicBulkSettingsPriceMap = {
    1: { price: 0.05 },
    2: { price: 0.05, foilPrice: 0.1 },
    3: { price: 0.05, foilPrice: 0.1 },
    4: { price: 0.1, foilPrice: 0.25 },
    5: { price: 0.25, foilPrice: 0.5 },
    6: { price: 0.5, foilPrice: 1 },
    7: { price: 1, foilPrice: 2 },
    8: { price: 0.5 },
    9: { price: 1 },
};
exports.magicBulkSettings = {
    _id: String(types_1.IdGame.Magic),
    gameId: types_1.IdGame.Magic,
    name: 'Default ' + types_1.GameName.Magic + ' Minimum Prices',
    priceMap: exports.magicBulkSettingsPriceMap,
};
exports.yugiohBulkSettingsPriceMap = {
    1: { price: 0.05 },
    2: { price: 0.05 },
    3: { price: 0.1 },
    4: { price: 0.1 },
    5: { price: 0.15 },
    6: { price: 0.15 },
    7: { price: 0.25 },
    8: { price: 0.25 },
    9: { price: 0.25 },
    10: { price: 0.5 },
    11: { price: 0.5 },
    12: { price: 0.5 },
    13: { price: 0.5 },
    14: { price: 0.5 },
    15: { price: 0.5 },
    16: { price: 0.5 },
    17: { price: 0.5 },
    18: { price: 0.5 },
    19: { price: 0.5 },
    20: { price: 1 },
};
exports.yugiohBulkSettings = {
    _id: String(types_1.IdGame.Yugioh),
    gameId: types_1.IdGame.Yugioh,
    name: 'Default ' + types_1.GameName.Yugioh + ' Minimum Prices',
    priceMap: exports.yugiohBulkSettingsPriceMap,
};
exports.pokemonBulkSettingsPriceMap = {
    1: { price: 0.05 },
    2: { price: 0.05 },
    3: { price: 0.05 },
    4: { price: 0.1 },
    5: { price: 0.25 },
    6: { price: 0.5 },
    7: { price: 1 },
    8: { price: 0.5 },
    9: { price: 1 },
    10: { price: 1 },
    11: { price: 1 },
    12: { price: 1 },
    13: { price: 1 },
};
exports.pokemonBulkSettings = {
    _id: String(types_1.IdGame.Pokemon),
    gameId: types_1.IdGame.Pokemon,
    name: 'Default ' + types_1.GameName.Pokemon + ' Minimum Prices',
    priceMap: exports.pokemonBulkSettingsPriceMap,
};
exports.vanguardBulkSettingsPriceMap = {
    1: { price: 0.05 },
    2: { price: 0.05 },
    3: { price: 0.05 },
    4: { price: 0.1 },
    5: { price: 0.25 },
    6: { price: 0.5 },
    7: { price: 1 },
    8: { price: 0.5 },
    9: { price: 1 },
    10: { price: 1 },
    11: { price: 1 },
    12: { price: 1 },
    13: { price: 1 },
};
exports.vanguardBulkSettings = {
    _id: String(types_1.IdGame.Vanguard),
    gameId: types_1.IdGame.Vanguard,
    name: 'Default ' + types_1.GameName.Vanguard + ' Minimum Prices',
    priceMap: exports.vanguardBulkSettingsPriceMap,
};
exports.DBSBulkSettingsPriceMap = {
    1: { price: 0.05 },
    2: { price: 0.05 },
    3: { price: 0.05 },
    4: { price: 0.1 },
    5: { price: 0.25, foilPrice: 0.5 },
    6: { price: 0.5, foilPrice: 1 },
    7: { price: 0.5, foilPrice: 1 },
    8: { price: 0.5, foilPrice: 1 },
    9: { price: 1, foilPrice: 1 },
    10: { price: 1 },
    11: { price: 1 },
    12: { price: 1 },
};
exports.DBSBulkSettings = {
    _id: String(types_1.IdGame.DBS),
    gameId: types_1.IdGame.DBS,
    name: 'Default ' + types_1.GameName.DBS + ' Minimum Prices',
    priceMap: exports.DBSBulkSettingsPriceMap,
};
exports.FFBulkSettingsPriceMap = {
    1: { price: 0.05 },
    2: { price: 0.05 },
    3: { price: 0.05 },
    4: { price: 0.1 },
    5: { price: 0.25 },
    6: { price: 0.5 },
};
exports.FFBulkSettings = {
    _id: String(types_1.IdGame.FF),
    gameId: types_1.IdGame.FF,
    name: 'Default ' + types_1.GameName.FF + ' Minimum Prices',
    priceMap: exports.FFBulkSettingsPriceMap,
};
exports.WSBulkSettingsPriceMap = {
    1: { price: 0.05 },
    2: { price: 0.05 },
    3: { price: 0.1 },
    4: { price: 0.1 },
    5: { price: 0.15 },
    6: { price: 0.15 },
    7: { price: 0.25 },
    8: { price: 0.25 },
    9: { price: 0.25 },
    10: { price: 0.5 },
    11: { price: 0.5 },
    12: { price: 0.5 },
    13: { price: 0.5 },
    14: { price: 0.5 },
    15: { price: 0.5 },
    16: { price: 0.5 },
    17: { price: 0.5 },
    18: { price: 0.5 },
    19: { price: 0.5 },
    20: { price: 1 },
    21: { price: 1 },
};
exports.WSBulkSettings = {
    _id: String(types_1.IdGame.WS),
    gameId: types_1.IdGame.WS,
    name: 'Default ' + types_1.GameName.WS + ' Minimum Prices',
    priceMap: exports.WSBulkSettingsPriceMap,
};
exports.FABBulkSettingsPriceMap = {
    1: { price: 0.05 },
    2: { price: 0.05 },
    3: { price: 0.1 },
    4: { price: 0.1 },
    5: { price: 0.15 },
    6: { price: 0.15 },
    7: { price: 0.25 },
    8: { price: 0.25 },
};
exports.FABBulkSettings = {
    _id: String(types_1.IdGame.FAB),
    gameId: types_1.IdGame.FAB,
    name: 'Default ' + types_1.GameName.FAB + ' Minimum Prices',
    priceMap: exports.FABBulkSettingsPriceMap,
};
exports.digimonBulkSettingsPriceMap = {
    1: { price: 0.05 },
    2: { price: 0.05 },
    3: { price: 0.1 },
    4: { price: 0.1 },
    5: { price: 0.15 },
    6: { price: 0.15 },
    7: { price: 0.25 },
    8: { price: 0.25 },
};
exports.digimonBulkSettings = {
    _id: String(types_1.IdGame.Digimon),
    gameId: types_1.IdGame.Digimon,
    name: 'Default ' + types_1.GameName.Digimon + ' Minimum Prices',
    priceMap: exports.digimonBulkSettingsPriceMap,
};
exports.onePieceBulkSettingsPriceMap = {
    1: { price: 0.05 },
    2: { price: 0.05 },
    3: { price: 0.1 },
    4: { price: 0.1 },
    5: { price: 0.15 },
    6: { price: 0.15 },
    7: { price: 0.25 },
    8: { price: 0.25 },
    9: { price: 0.25 },
    10: { price: 10 },
    11: { price: 5 },
};
exports.onePieceBulkSettings = {
    _id: String(types_1.IdGame.OnePiece),
    gameId: types_1.IdGame.OnePiece,
    name: 'Default ' + types_1.GameName.OnePiece + ' Minimum Prices',
    priceMap: exports.onePieceBulkSettingsPriceMap,
};
exports.lorcanaBulkSettingsPriceMap = {
    1: { price: 0.05, foilPrice: 1 },
    2: { price: 0.05, foilPrice: 2 },
    3: { price: 0.1, foilPrice: 4 },
    4: { price: 0.1, foilPrice: 4 },
    5: { price: 0.25, foilPrice: 8 },
    6: { price: 0.5 },
    7: { price: 0.5 },
    8: { price: 10 },
    9: { price: 10 },
    10: { price: 20 },
};
exports.lorcanaBulkSettings = {
    _id: String(types_1.IdGame.Lorcana),
    gameId: types_1.IdGame.Lorcana,
    name: 'Default ' + types_1.GameName.Lorcana + ' Minimum Prices',
    priceMap: exports.lorcanaBulkSettingsPriceMap,
};
// BSS
exports.bssBulkSettingsPriceMap = {
    1: { price: 0.05 },
    2: { price: 0.05 },
    3: { price: 0.1 },
    4: { price: 0.1 },
    5: { price: 0.25 },
    6: { price: 0.25 },
    7: { price: 0.25 },
    8: { price: 0.5 },
    9: { price: 0.5 },
    10: { price: 0.5 },
};
exports.bssBulkSettings = {
    _id: String(types_1.IdGame.BSS),
    gameId: types_1.IdGame.BSS,
    name: 'Default ' + types_1.GameName.BSS + ' Minimum Prices',
    priceMap: exports.bssBulkSettingsPriceMap,
};
// SWU
exports.swuBulkSettingsPriceMap = {
    1: { price: 0.05 },
    2: { price: 0.05 },
    3: { price: 0.1 },
    4: { price: 0.5 },
    5: { price: 1.0 },
};
exports.swuBulkSettings = {
    _id: String(types_1.IdGame.SWU),
    gameId: types_1.IdGame.SWU,
    name: 'Default ' + types_1.GameName.SWU + ' Minimum Prices',
    priceMap: exports.swuBulkSettingsPriceMap,
};
// Riftbound
exports.riftboundBulkSettingsPriceMap = {
    1: { price: 0.05, foilPrice: 0.1 },
    2: { price: 0.05, foilPrice: 0.1 },
    3: { price: 0.1, foilPrice: 0.25 },
    4: { price: 0.5, foilPrice: 1 },
    5: { price: 1.0, foilPrice: 2 },
};
exports.riftboundBulkSettings = {
    _id: String(types_1.IdGame.Riftbound),
    gameId: types_1.IdGame.Riftbound,
    name: 'Default ' + types_1.GameName.Riftbound + ' Minimum Prices',
    priceMap: exports.riftboundBulkSettingsPriceMap,
};
// Cyberpunk
exports.cyberpunkBulkSettingsPriceMap = {
    1: { price: 0.05 },
    2: { price: 0.05 },
    3: { price: 0.1, foilPrice: 0.25 },
    4: { price: 0.5, foilPrice: 1 },
    5: { price: 2.0, foilPrice: 4 },
    6: { price: 2.0, foilPrice: 4 },
    7: { price: 2.0, foilPrice: 4 },
};
exports.cyberpunkBulkSettings = {
    _id: String(types_1.IdGame.Cyberpunk),
    gameId: types_1.IdGame.Cyberpunk,
    name: 'Default ' + types_1.GameName.Cyberpunk + ' Minimum Prices',
    priceMap: exports.cyberpunkBulkSettingsPriceMap,
};
// Gundam
exports.gundamBulkSettingsPriceMap = {
    1: { price: 0.05 },
    2: { price: 0.1 },
    3: { price: 0.05 },
    4: { price: 0.1 },
    5: { price: 0.1 },
    6: { price: 0.25 },
    7: { price: 0.5 },
    8: { price: 1 },
    9: { price: 2 },
    10: { price: 2 },
    11: { price: 0.05 },
    12: { price: 0.1 },
    13: { price: 0.25 },
    14: { price: 0.05 },
};
exports.gundamBulkSettings = {
    _id: String(types_1.IdGame.Gundam),
    gameId: types_1.IdGame.Gundam,
    name: 'Default ' + types_1.GameName.Gundam + ' Minimum Prices',
    priceMap: exports.gundamBulkSettingsPriceMap,
};
// Sorcery
exports.sorceryBulkSettingsPriceMap = {
    1: { price: 0.05 },
    2: { price: 0.1 },
    3: { price: 0.25 },
    4: { price: 0.5 },
    5: { price: 0.25 },
    6: { price: 0.05 },
};
exports.sorceryBulkSettings = {
    _id: String(types_1.IdGame.Sorcery),
    gameId: types_1.IdGame.Sorcery,
    name: 'Default ' + types_1.GameName.Sorcery + ' Minimum Prices',
    priceMap: exports.sorceryBulkSettingsPriceMap,
};
exports.BULL_MQ_KEEP_JOBS_VALUES = {
    age: 60 * 60 * 12,
    count: 100,
};
exports.BULL_MQ_KEEP_JOBS_VALUES_TEST = {
    age: 5,
    count: 100,
};
exports.OUTSETA_STAGES = {
    2: 'Trialing',
    3: 'Subscribing',
    4: 'Cancelling',
    5: 'Expired',
    6: 'TrialExpired',
    7: 'PastDue',
};
exports.ORDER_TABS = [
    {
        states: '',
        filters: [
            'pending',
            'paid',
            'picking',
            'picked',
            'packed',
            'sent',
            'issues',
            'cancelled',
            'sealed',
            'presale',
        ],
    },
    {
        states: ['bought', 'paid', 'picking'],
        filters: ['pending', 'paid', 'picking', 'issues', 'sealed', 'presale'],
    },
    { states: ['picking', 'picked'], filters: ['picking', 'picked'] },
    {
        states: ['picked', 'packed', 'sent'],
        filters: ['picked', 'packed', 'sent', 'issues', 'sealed', 'presale'],
    },
    { states: ['received', 'evaluated'], filters: ['received', 'evaluated'] },
    { states: [], filters: [] },
];
exports.ORDER_SIDEBAR_TABS = {
    FULFILMENT_CENTER: 0,
    MANAGE_PICKING_LISTS: 1,
    PICK_ARTICLES: 2,
    PACKAGE: 3,
    COMPLETED: 4,
};
exports.NUM_ARTICLES_FETCHED_KEY = 'numArticlesFetched';
exports.ARTICLE_DATA_FETCHING_RUNTIME_MAIN_KEY = 'articleDataFetchingRuntimeMain';
exports.ARTICLE_DATA_FETCHING_RUNTIME_FAST_KEY = 'articleDataFetchingRuntimeFast';
exports.NUM_OLD_ARTICLES_KEY = 'numOldArticles';
exports.NUM_429_ERRORS_KEY = 'num429Errors';
exports.FETCHING_JOURNAL_KEY = 'fj';
exports.ORDER_FILTERS = [
    {
        name: 'all',
        state: 'all',
        label: 'All',
        boxColor: '#013685',
        textColor: 'white',
        defaultActive: true,
    },
    {
        name: 'pending',
        state: 'bought',
        label: 'Pending',
        boxColor: '#b6cc34',
        textColor: 'white',
        defaultActive: true,
    },
    {
        name: 'paid',
        state: 'paid',
        label: 'Paid',
        boxColor: '#70bf4c',
        textColor: 'white',
        defaultActive: true,
    },
    {
        name: 'picking',
        state: 'picking',
        label: 'Picking',
        boxColor: '#00bbbe',
        textColor: 'white',
        defaultActive: true,
    },
    {
        name: 'picked',
        state: 'picked',
        label: 'Picked',
        boxColor: '#0087b8ff',
        textColor: 'white',
        defaultActive: true,
    },
    {
        name: 'packed',
        state: 'packed',
        label: 'Packed',
        boxColor: '#0079b2',
        textColor: 'white',
        defaultActive: true,
    },
    {
        name: 'sent',
        state: 'sent',
        label: 'Sent',
        boxColor: '#006898',
        textColor: 'white',
        defaultActive: true,
    },
    {
        name: 'received',
        state: 'received',
        label: 'Received',
        boxColor: '#43ce61ff',
        textColor: 'black',
        defaultActive: true,
    },
    {
        name: 'evaluated',
        state: 'evaluated',
        label: 'Evaluated',
        boxColor: '#45d664ff',
        textColor: 'black',
        defaultActive: true,
    },
    {
        name: 'messages',
        state: 'messages',
        label: 'Messages',
        boxColor: '#d4b630ff',
        textColor: 'black',
        defaultActive: false,
    },
    {
        name: 'issues',
        state: 'issues',
        label: 'Issues',
        boxColor: '#d64828ff',
        textColor: 'white',
        defaultActive: false,
    },
    {
        name: 'cancelled',
        state: 'canceled',
        label: 'Cancelled',
        boxColor: '#d67d25ff',
        textColor: 'white',
        defaultActive: false,
    },
    {
        name: 'magic',
        state: 'Magic',
        label: 'Magic',
        boxColor: '',
        textColor: '',
        defaultActive: true,
        isGame: true,
    },
    {
        name: 'yugioh',
        state: 'YuGiOh',
        label: 'YuGiOh',
        boxColor: '',
        textColor: '',
        defaultActive: true,
        isGame: true,
    },
    {
        name: 'pokemon',
        state: 'Pokemon',
        label: 'Pokemon',
        boxColor: '',
        textColor: '',
        defaultActive: true,
        isGame: true,
    },
    {
        name: 'vanguard',
        state: 'Vanguard',
        label: 'Vanguard',
        boxColor: '',
        textColor: '',
        defaultActive: true,
        isGame: true,
    },
    {
        name: 'ff',
        state: 'FF',
        label: 'FF',
        boxColor: '',
        textColor: '',
        defaultActive: true,
        isGame: true,
    },
    {
        name: 'dbs',
        state: 'DBS',
        label: 'DBS',
        boxColor: '',
        textColor: '',
        defaultActive: true,
        isGame: true,
    },
    {
        name: 'ws',
        state: 'WS',
        label: 'WS',
        boxColor: '',
        textColor: '',
        defaultActive: true,
        isGame: true,
    },
    {
        name: 'fab',
        state: 'FAB',
        label: 'FAB',
        boxColor: '',
        textColor: '',
        defaultActive: true,
        isGame: true,
    },
    {
        name: 'digimon',
        state: 'Digimon',
        label: 'Digimon',
        boxColor: '',
        textColor: '',
        defaultActive: true,
        isGame: true,
    },
    {
        name: 'onepiece',
        state: 'OnePiece',
        label: 'OnePiece',
        boxColor: '',
        textColor: '',
        defaultActive: true,
        isGame: true,
    },
    {
        name: 'lorcana',
        state: 'Lorcana',
        label: 'Lorcana',
        boxColor: '',
        textColor: '',
        defaultActive: true,
        isGame: true,
    },
    {
        name: 'bss',
        state: 'BSS',
        label: 'BSS',
        boxColor: '',
        textColor: '',
        defaultActive: true,
        isGame: true,
    },
    {
        name: 'swu',
        state: 'SWU',
        label: 'SWU',
        boxColor: '',
        textColor: '',
        defaultActive: true,
        isGame: true,
    },
    {
        name: 'riftbound',
        state: 'Riftbound',
        label: 'Riftbound',
        boxColor: '',
        textColor: '',
        defaultActive: true,
        isGame: true,
    },
    {
        name: 'cyberpunk',
        state: 'Cyberpunk',
        label: 'Cyberpunk',
        boxColor: '',
        textColor: '',
        defaultActive: true,
        isGame: true,
    },
    {
        name: 'gundam',
        state: 'Gundam',
        label: 'Gundam',
        boxColor: '',
        textColor: '',
        defaultActive: true,
        isGame: true,
    },
    {
        name: 'sorcery',
        state: 'Sorcery',
        label: 'Sorcery',
        boxColor: '',
        textColor: '',
        defaultActive: true,
        isGame: true,
    },
    {
        name: 'sealed',
        state: 'sealed',
        label: 'Sealed',
        boxColor: '#d49c00',
        textColor: 'white',
        defaultActive: false,
    },
    {
        name: 'presale',
        state: 'presale',
        label: 'Presale',
        boxColor: '#8365db',
        textColor: 'white',
        defaultActive: false,
    },
];
exports.ORDER_STATES = [
    {
        name: 'bought',
        label: 'Bought',
        boxColor: '#b6cc34',
        textColor: 'white',
    },
    {
        name: 'paid',
        label: 'Paid',
        boxColor: '#70bf4c',
        textColor: 'white',
    },
    {
        name: 'picking',
        label: 'Picking',
        boxColor: '#00bbbe',
        textColor: 'white',
    },
    {
        name: 'picked',
        label: 'Picked',
        boxColor: '#00a0dc',
        textColor: 'white',
    },
    {
        name: 'packed',
        label: 'Packed',
        boxColor: '#0079b2',
        textColor: 'white',
    },
    {
        name: 'cancellationRequested',
        label: 'Cancelling',
        boxColor: '',
        textColor: '',
    },
    {
        name: 'canceled',
        label: 'Cancelled',
        boxColor: '#f1973e',
        textColor: 'white',
    },
    {
        name: 'sent',
        label: 'Sent',
        boxColor: '#006898',
        textColor: 'white',
    },
    {
        name: 'lost',
        label: 'Lost',
        boxColor: '',
        textColor: '',
    },
    {
        name: 'received',
        label: 'Received',
        boxColor: '#3581B8',
        textColor: 'white',
    },
    {
        name: 'evaluated',
        label: 'Evaluated',
        boxColor: '#5AA9E6',
        textColor: 'white',
    },
];
exports.ORDER_PROPS = [
    {
        name: 'issues',
        label: 'issues',
        boxColor: '#f15e3e',
        textColor: 'white',
    },
];
var ARTICLE_STATES;
(function (ARTICLE_STATES) {
    ARTICLE_STATES["TO_PICK"] = "toPick";
    ARTICLE_STATES["PICKED"] = "picked";
    ARTICLE_STATES["WITH_ISSUE"] = "withIssue";
})(ARTICLE_STATES = exports.ARTICLE_STATES || (exports.ARTICLE_STATES = {}));
exports.TimePreset = {
    ONE_MINUTE: 60,
    ONE_HOUR: 60 * 60,
    ONE_DAY: 60 * 60 * 24,
};
exports.VIDEO_TUTORIALS = [
    {
        title: 'manualSinglesAdd',
        videoId: 'JLHTtC-q_DU',
    },
    {
        title: 'csvImportSingles',
        videoId: 'RpfJhHrsqtY',
    },
    {
        title: 'manualAccessoriesAdd',
        videoId: 'UUR038Po8FE',
    },
    {
        title: 'csvImportAccessories',
        videoId: 'sdYhGi6p0So',
    },
    {
        title: 'priceSettings',
        videoId: 'sD0bH9TsfcM',
    },
    {
        title: 'collectionAppraisal',
        videoId: '_xiEYF8x7-g',
    },
    {
        title: 'pricingBot',
        videoId: '94-W5cOrrNs',
    },
    {
        title: 'orderManagement',
        videoId: 'ZAQaGWMfQDk',
    },
];
exports.PRICING_DEFAULTS = {
    maxDecrease: 5,
    maxIncrease: 100,
};
exports.INVENTORY_STEPS = {
    WELCOME: {
        idx: 0,
        label: '',
    },
    CONNECT_ACCOUNT: {
        idx: 1,
        label: 'selectMethod',
    },
    STOCK_REVIEW: {
        idx: 2,
        label: 'reviewImport',
    },
    SOURCE_SELECTION: {
        idx: 3,
        label: 'selectSource',
    },
    SOLVE_CONFLICTS: {
        idx: 4,
        label: 'solveConflicts',
    },
    PRICE_SELECTION: {
        idx: 5,
        label: 'selectPrices',
    },
    FINISH: {
        idx: 6,
        label: 'readyToGo',
    },
};
exports.ONBOARDING_STEPS = {
    WELCOME: {
        idx: 0,
        label: '',
    },
    CONNECT_CARDMARKET_ACCOUNT: {
        idx: 1,
        label: 'connectCardmarketAccount',
    },
    SEPA_MANDATE: {
        idx: 2,
        label: 'sepaMandate',
    },
    HOW_POWERTOOLS_WORKS: {
        idx: 3,
        label: 'howPowertoolsWorks',
    },
    EMPTY_STOCK: {
        idx: 4,
        label: 'emptyStock',
    },
    LOADING: {
        idx: 5,
        label: 'loading',
    },
    COMMENTS_FORM: {
        idx: 6,
        label: 'commentsForm',
    },
    SET_PRICES: {
        idx: 7,
        label: 'setPrices',
    },
    CHOOSE_NEXT_STEP: {
        idx: 8,
        label: 'chooseNextStep',
    },
    SET_COMMENTS_LOCATIONS: {
        idx: 9,
        label: 'setCommentsAndLocations',
    },
    DOWNLOAD_FETCHED_STOCK: {
        idx: 10,
        label: 'downloadFetchedStock',
    },
    IMPORT_CSV: {
        idx: 11,
        label: 'importCsv',
    },
    // CONGRATULATIONS: {
    //   idx: 12,
    //   label: 'congratulations',
    // },
    CONTACTS_FOR_HELP: {
        idx: 12,
        label: 'contactsForHelp',
    },
    STEP_SHOPIFY: {
        idx: 13,
        label: 'syncFromShopify',
    },
};
exports.INVENTORY_ZOOM_LEVELS = {
    ARTICLE: 'ptArticle',
    LOCATION: 'location',
};
exports.ONBOARDING_SOURCE_SYNC = {
    CSV: 'csv',
    CARDMARKET: 'cardmarket',
    CARDTRADER: 'cardtrader',
    SHOPIFY: 'shopify',
    NO_STOCK: 'noStock',
};
exports.INVENTORY_TRANSACTION_TYPE = {
    QUANTITY: 'quantity',
    PRICE: 'price',
    MKM_ORDER: 'cardmarketOrder',
    RESERVATION: 'reservation',
    POWERTOOLS: 'powertools',
    CARDMARKET: 'cardmarket',
    BUY_PRICE: 'buyPrice',
    TAX_TRANSACTION: 'tax',
};
exports.INVENTORY_TRANSACTION_CAUSES = {
    MANUAL_SYNC: 'Manual Sync',
    ORDERS_SYNC: 'Orders Sync',
    MANUAL_CHANGE: 'Manual Change',
    MANUAL_AUTOPRICING: 'Manual Autopricing',
    PRICING_BOT: 'Pricing Bot',
    MANUAL_BOT_RUN: 'Manual Bot Run',
    ONBOARDING_SYNC: 'Onboarding Sync',
    ONBOARDING_CSV: 'Onboarding CSV',
};
exports.INVENTORY_TRANSACTION_SOURCES = {
    POWERTOOLS: 'PowerTools',
    CARDMARKET: 'Cardmarket',
};
var INVENTORY_MULTI_SELECTION_UPDATES;
(function (INVENTORY_MULTI_SELECTION_UPDATES) {
    INVENTORY_MULTI_SELECTION_UPDATES["NEW_COMMENT"] = "newComment";
    INVENTORY_MULTI_SELECTION_UPDATES["NEW_QUANTITY"] = "newQuantity";
    INVENTORY_MULTI_SELECTION_UPDATES["NEW_LOCATION"] = "newLocation";
    INVENTORY_MULTI_SELECTION_UPDATES["NEW_PRICE"] = "newPrice";
    INVENTORY_MULTI_SELECTION_UPDATES["NEW_CONDITION"] = "newCondition";
    INVENTORY_MULTI_SELECTION_UPDATES["NEW_TAXATION_SCHEME"] = "newTaxationScheme";
})(INVENTORY_MULTI_SELECTION_UPDATES = exports.INVENTORY_MULTI_SELECTION_UPDATES || (exports.INVENTORY_MULTI_SELECTION_UPDATES = {}));
exports.CARD_LANGUAGES_WITH_FLAGS = [
    { label: 'EN', value: types_1.CardLanguage.English, code: 'GB', extendedLabel: 'English' },
    { label: 'FR', value: types_1.CardLanguage.French, code: 'FR', extendedLabel: 'French' },
    { label: 'DE', value: types_1.CardLanguage.German, code: 'DE', extendedLabel: 'German' },
    { label: 'ES', value: types_1.CardLanguage.Spanish, code: 'ES', extendedLabel: 'Spanish' },
    { label: 'IT', value: types_1.CardLanguage.Italian, code: 'IT', extendedLabel: 'Italian' },
    { label: 'S-ZH', value: types_1.CardLanguage['S-Chinese'], code: 'CN', extendedLabel: 'S-Chinese' },
    { label: 'JP', value: types_1.CardLanguage.Japanese, code: 'JP', extendedLabel: 'Japanese' },
    { label: 'PT', value: types_1.CardLanguage.Portuguese, code: 'PT', extendedLabel: 'Portuguese' },
    { label: 'RU', value: types_1.CardLanguage.Russian, code: 'RU', extendedLabel: 'Russian' },
    { label: 'KO', value: types_1.CardLanguage.Korean, code: 'KR', extendedLabel: 'Korean' },
    { label: 'T-ZH', value: types_1.CardLanguage['T-Chinese'], code: 'TW', extendedLabel: 'T-Chinese' },
    { label: 'NL', value: types_1.CardLanguage.Dutch, code: 'NL', extendedLabel: 'Dutch' },
    { label: 'PL', value: types_1.CardLanguage.Polish, code: 'PL', extendedLabel: 'Polish' },
    { label: 'CZ', value: types_1.CardLanguage.Czech, code: 'CZ', extendedLabel: 'Czech' },
    { label: 'HU', value: types_1.CardLanguage.Hungarian, code: 'HU', extendedLabel: 'Hungarian' },
    { label: 'ID', value: types_1.CardLanguage.Indonesian, code: 'ID', extendedLabel: 'Indonesian' },
    { label: 'TH', value: types_1.CardLanguage.Thai, code: 'TH', extendedLabel: 'Thai' },
];
var flagCode = function (id) { var _a; return (_a = exports.CARD_LANGUAGES_WITH_FLAGS.find(function (language) { return language.value === id; })) === null || _a === void 0 ? void 0 : _a.code; };
exports.flagCode = flagCode;
exports.CONDITIONS_MAP_WITH_LABELS = [
    { name: 'MT', value: 0, code: 'MT' },
    { name: 'NM', value: 1, code: 'NM' },
    { name: 'EX', value: 2, code: 'EX' },
    { name: 'GD', value: 3, code: 'GD' },
    { name: 'LP', value: 4, code: 'LP' },
    { name: 'PL', value: 5, code: 'PL' },
    { name: 'PO', value: 6, code: 'PO' },
];
var CountryEdition;
(function (CountryEdition) {
    CountryEdition["Regular"] = "Regular";
    CountryEdition["US"] = "US";
})(CountryEdition = exports.CountryEdition || (exports.CountryEdition = {}));
// backend enum
var FINISH_TYPES;
(function (FINISH_TYPES) {
    FINISH_TYPES[FINISH_TYPES["REGULAR"] = 0] = "REGULAR";
    FINISH_TYPES[FINISH_TYPES["FOIL"] = 1] = "FOIL";
    FINISH_TYPES[FINISH_TYPES["COLD_FOIL"] = 2] = "COLD_FOIL";
    FINISH_TYPES[FINISH_TYPES["RAINBOW_FOIL"] = 3] = "RAINBOW_FOIL";
    FINISH_TYPES[FINISH_TYPES["REVERSE_HOLO"] = 4] = "REVERSE_HOLO";
    FINISH_TYPES[FINISH_TYPES["STAMPED_HOLO"] = 5] = "STAMPED_HOLO";
    FINISH_TYPES[FINISH_TYPES["REVERSE_STAMPED_HOLO"] = 6] = "REVERSE_STAMPED_HOLO";
    FINISH_TYPES[FINISH_TYPES["ICE_CRACKED_HOLO"] = 7] = "ICE_CRACKED_HOLO";
    FINISH_TYPES[FINISH_TYPES["REVERSE_ICE_CRACKED_HOLO"] = 8] = "REVERSE_ICE_CRACKED_HOLO";
    FINISH_TYPES[FINISH_TYPES["MASTERBALL_HOLO"] = 9] = "MASTERBALL_HOLO";
    FINISH_TYPES[FINISH_TYPES["REVERSE_MASTERBALL_HOLO"] = 10] = "REVERSE_MASTERBALL_HOLO";
    FINISH_TYPES[FINISH_TYPES["POKEBALL_HOLO"] = 11] = "POKEBALL_HOLO";
    FINISH_TYPES[FINISH_TYPES["REVERSE_POKEBALL_HOLO"] = 12] = "REVERSE_POKEBALL_HOLO";
    FINISH_TYPES[FINISH_TYPES["COSMOS_HOLO"] = 13] = "COSMOS_HOLO";
    FINISH_TYPES[FINISH_TYPES["REVERSE_COSMOS_HOLO"] = 14] = "REVERSE_COSMOS_HOLO";
})(FINISH_TYPES = exports.FINISH_TYPES || (exports.FINISH_TYPES = {}));
// frontend enum
var FINISH_TYPE_LABELS;
(function (FINISH_TYPE_LABELS) {
    FINISH_TYPE_LABELS["REGULAR"] = "Regular";
    FINISH_TYPE_LABELS["FOIL"] = "Foil";
    FINISH_TYPE_LABELS["COLD_FOIL"] = "ColdFoil";
    FINISH_TYPE_LABELS["RAINBOW_FOIL"] = "RainbowFoil";
    FINISH_TYPE_LABELS["REVERSE_HOLO"] = "ReverseHolo";
    FINISH_TYPE_LABELS["STAMPED_HOLO"] = "StampedHolo";
    FINISH_TYPE_LABELS["REVERSE_STAMPED_HOLO"] = "ReverseStampedHolo";
    FINISH_TYPE_LABELS["ICE_CRACKED_HOLO"] = "IceCrackedHolo";
    FINISH_TYPE_LABELS["REVERSE_ICE_CRACKED_HOLO"] = "ReverseIceCrackedHolo";
    FINISH_TYPE_LABELS["MASTERBALL_HOLO"] = "MasterballHolo";
    FINISH_TYPE_LABELS["REVERSE_MASTERBALL_HOLO"] = "ReverseMasterballHolo";
    FINISH_TYPE_LABELS["POKEBALL_HOLO"] = "PokeballHolo";
    FINISH_TYPE_LABELS["REVERSE_POKEBALL_HOLO"] = "ReversePokeballHolo";
    FINISH_TYPE_LABELS["COSMOS_HOLO"] = "CosmosHolo";
    FINISH_TYPE_LABELS["REVERSE_COSMOS_HOLO"] = "ReverseCosmosHolo";
})(FINISH_TYPE_LABELS = exports.FINISH_TYPE_LABELS || (exports.FINISH_TYPE_LABELS = {}));
exports.FINISH_TYPES_CONVERSIONS = [
    { label: FINISH_TYPE_LABELS.REGULAR, code: FINISH_TYPES.REGULAR },
    { label: FINISH_TYPE_LABELS.FOIL, code: FINISH_TYPES.FOIL },
    { label: FINISH_TYPE_LABELS.COLD_FOIL, code: FINISH_TYPES.COLD_FOIL },
    { label: FINISH_TYPE_LABELS.RAINBOW_FOIL, code: FINISH_TYPES.RAINBOW_FOIL },
    { label: FINISH_TYPE_LABELS.REVERSE_HOLO, code: FINISH_TYPES.REVERSE_HOLO },
    { label: FINISH_TYPE_LABELS.STAMPED_HOLO, code: FINISH_TYPES.STAMPED_HOLO },
    { label: FINISH_TYPE_LABELS.REVERSE_STAMPED_HOLO, code: FINISH_TYPES.REVERSE_STAMPED_HOLO },
    { label: FINISH_TYPE_LABELS.ICE_CRACKED_HOLO, code: FINISH_TYPES.ICE_CRACKED_HOLO },
    {
        label: FINISH_TYPE_LABELS.REVERSE_ICE_CRACKED_HOLO,
        code: FINISH_TYPES.REVERSE_ICE_CRACKED_HOLO,
    },
    { label: FINISH_TYPE_LABELS.MASTERBALL_HOLO, code: FINISH_TYPES.MASTERBALL_HOLO },
    { label: FINISH_TYPE_LABELS.REVERSE_MASTERBALL_HOLO, code: FINISH_TYPES.REVERSE_MASTERBALL_HOLO },
    { label: FINISH_TYPE_LABELS.POKEBALL_HOLO, code: FINISH_TYPES.POKEBALL_HOLO },
    { label: FINISH_TYPE_LABELS.REVERSE_POKEBALL_HOLO, code: FINISH_TYPES.REVERSE_POKEBALL_HOLO },
    { label: FINISH_TYPE_LABELS.COSMOS_HOLO, code: FINISH_TYPES.COSMOS_HOLO },
    { label: FINISH_TYPE_LABELS.REVERSE_COSMOS_HOLO, code: FINISH_TYPES.REVERSE_COSMOS_HOLO },
];
// solo finish speciali, escludendo regular, usato durante il listing
exports.FINISH_ATTRIBUTES = Object.values(FINISH_TYPE_LABELS).filter(function (label) { return label !== FINISH_TYPE_LABELS.REGULAR; });
var COUNTRY_EDITION;
(function (COUNTRY_EDITION) {
    COUNTRY_EDITION[COUNTRY_EDITION["REGULAR"] = 0] = "REGULAR";
    COUNTRY_EDITION[COUNTRY_EDITION["US_EDITION"] = 1] = "US_EDITION";
})(COUNTRY_EDITION = exports.COUNTRY_EDITION || (exports.COUNTRY_EDITION = {}));
exports.countryEditionMap = [
    { label: 'Regular', value: CountryEdition.Regular, code: COUNTRY_EDITION.REGULAR },
    { label: 'US', value: CountryEdition.US, code: COUNTRY_EDITION.US_EDITION },
];
var PRICING_BOT_SOURCE;
(function (PRICING_BOT_SOURCE) {
    PRICING_BOT_SOURCE[PRICING_BOT_SOURCE["CARDMARKET"] = 0] = "CARDMARKET";
    PRICING_BOT_SOURCE[PRICING_BOT_SOURCE["CARDTRADER"] = 1] = "CARDTRADER";
})(PRICING_BOT_SOURCE = exports.PRICING_BOT_SOURCE || (exports.PRICING_BOT_SOURCE = {}));
var PICKING_SORTING_FIELDS;
(function (PICKING_SORTING_FIELDS) {
    PICKING_SORTING_FIELDS["NONE"] = "none";
    PICKING_SORTING_FIELDS["EXTRAS"] = "extras";
    PICKING_SORTING_FIELDS["GAME_ASC"] = "game.asc";
    PICKING_SORTING_FIELDS["GAME_DESC"] = "game.desc";
    PICKING_SORTING_FIELDS["PRODUCT_EXPANSION_ASC"] = "product.expansion.asc";
    PICKING_SORTING_FIELDS["PRODUCT_EXPANSION_DESC"] = "product.expansion.desc";
    PICKING_SORTING_FIELDS["PRODUCT_RARITY_ASC"] = "product.rarity.asc";
    PICKING_SORTING_FIELDS["PRODUCT_RARITY_DESC"] = "product.rarity.desc";
    PICKING_SORTING_FIELDS["LOCATION_ASC"] = "location.asc";
    PICKING_SORTING_FIELDS["LOCATION_DESC"] = "location.desc";
    PICKING_SORTING_FIELDS["PRODUCT_EN_NAME_ASC"] = "product.enName.asc";
    PICKING_SORTING_FIELDS["PRODUCT_EN_NAME_DESC"] = "product.enName.desc";
    PICKING_SORTING_FIELDS["PRODUCT_LOC_NAME_ASC"] = "product.locName.asc";
    PICKING_SORTING_FIELDS["PRODUCT_LOC_NAME_DESC"] = "product.locName.desc";
    PICKING_SORTING_FIELDS["CN_ASC"] = "cn.asc";
    PICKING_SORTING_FIELDS["CN_DESC"] = "cn.desc";
    PICKING_SORTING_FIELDS["CONDITION_ASC"] = "condition.asc";
    PICKING_SORTING_FIELDS["CONDITION_DESC"] = "condition.desc";
    PICKING_SORTING_FIELDS["LANGUAGE_ASC"] = "language.asc";
    PICKING_SORTING_FIELDS["LANGUAGE_DESC"] = "language.desc";
    PICKING_SORTING_FIELDS["COMMENT_ASC"] = "comment.asc";
    PICKING_SORTING_FIELDS["COMMENT_DESC"] = "comment.desc";
    PICKING_SORTING_FIELDS["PRICE_ASC"] = "price.asc";
    PICKING_SORTING_FIELDS["PRICE_DESC"] = "price.desc";
    PICKING_SORTING_FIELDS["ORDER_BIN_ASC"] = "orderBin.asc";
    PICKING_SORTING_FIELDS["ORDER_BIN_DESC"] = "orderBin.desc";
    PICKING_SORTING_FIELDS["COLOR_ASC"] = "color.asc";
    PICKING_SORTING_FIELDS["COLOR_DESC"] = "color.desc";
    PICKING_SORTING_FIELDS["RELEASE_DATE_ASC"] = "releaseDate.asc";
    PICKING_SORTING_FIELDS["RELEASE_DATE_DESC"] = "releaseDate.desc";
    PICKING_SORTING_FIELDS["SET_ASC"] = "set.asc";
    PICKING_SORTING_FIELDS["SET_DESC"] = "set.desc";
    PICKING_SORTING_FIELDS["RELEASE_EXP_CODE_ASC"] = "releaseExpCode.asc";
    PICKING_SORTING_FIELDS["RELEASE_EXP_CODE_DESC"] = "releaseExpCode.desc";
})(PICKING_SORTING_FIELDS = exports.PICKING_SORTING_FIELDS || (exports.PICKING_SORTING_FIELDS = {}));
/**
 * Full name and the code we store, which is what an article carries.
 *
 * The same list lives in the Rails seed db/seeds/grading_companies.rb, which owns the companies and their grades:
 * a company added there has to be added here too, or Node stops recognizing it in a comment and stops offering it
 * to the seller. Kept as a constant rather than fetched because reading a comment must not depend on a request
 * having succeeded — a graded card Node fails to recognize is published a second time.
 */
exports.GRADING_COMPANY_LABELS = [
    { label: 'Professional Sports Authenticator', code: 'PSA' },
    { label: 'Beckett Grading Services', code: 'BGS' },
    { label: 'Grade Authority and Authentication Division', code: 'GRAAD' },
    { label: 'AiGrading', code: 'AiGrad' },
    { label: 'Ace Grading', code: 'ACE' },
    { label: 'Certificateur de Cartes de Collection', code: 'CCC' },
    { label: 'Certified Guaranty Company', code: 'CGC' },
    { label: 'Absolute Objective Grading', code: 'AOG' },
    { label: 'AP Grading', code: 'AP' },
    { label: 'Blade Grading', code: 'BLADE' },
    { label: 'Technical Authentication & Grading', code: 'TAG' },
    { label: 'Collect Aura', code: 'AURA' },
    { label: 'Platin Grading Service', code: 'PGS' },
    { label: 'Premier Card Grading', code: 'PCG' },
    { label: 'Professional Card Authenticator', code: 'PCA' },
];
exports.PURCHASE_EVENTS_STORE_SIZE = 10;
var TAXATION_ICON_VISIBILITY;
(function (TAXATION_ICON_VISIBILITY) {
    TAXATION_ICON_VISIBILITY["ALL"] = "all";
    TAXATION_ICON_VISIBILITY["ONLY_DIFFERENT"] = "onlyDifferent";
})(TAXATION_ICON_VISIBILITY = exports.TAXATION_ICON_VISIBILITY || (exports.TAXATION_ICON_VISIBILITY = {}));
var TAXATION_SCHEME;
(function (TAXATION_SCHEME) {
    TAXATION_SCHEME[TAXATION_SCHEME["STANDARD"] = 0] = "STANDARD";
    TAXATION_SCHEME[TAXATION_SCHEME["MARGIN"] = 1] = "MARGIN";
})(TAXATION_SCHEME = exports.TAXATION_SCHEME || (exports.TAXATION_SCHEME = {}));
var TAXATION_SCHEME_LABELS;
(function (TAXATION_SCHEME_LABELS) {
    TAXATION_SCHEME_LABELS["STANDARD"] = "Standard";
    TAXATION_SCHEME_LABELS["MARGIN"] = "Margin";
})(TAXATION_SCHEME_LABELS = exports.TAXATION_SCHEME_LABELS || (exports.TAXATION_SCHEME_LABELS = {}));
exports.TAXATION_SCHEME_CONVERSIONS = [
    { label: TAXATION_SCHEME_LABELS.STANDARD, code: TAXATION_SCHEME.STANDARD },
    { label: TAXATION_SCHEME_LABELS.MARGIN, code: TAXATION_SCHEME.MARGIN },
];
var SPLITTING_STRATEGY;
(function (SPLITTING_STRATEGY) {
    SPLITTING_STRATEGY[SPLITTING_STRATEGY["MANUAL"] = 0] = "MANUAL";
    SPLITTING_STRATEGY[SPLITTING_STRATEGY["STRATEGY_DEFAULT"] = 2] = "STRATEGY_DEFAULT";
    SPLITTING_STRATEGY[SPLITTING_STRATEGY["AUTOPRICER"] = 3] = "AUTOPRICER";
})(SPLITTING_STRATEGY = exports.SPLITTING_STRATEGY || (exports.SPLITTING_STRATEGY = {}));
exports.SPLITTING_STRATEGY_CONVERSIONS = [
    { label: 'Manual', code: 0, backendTypeCast: 'manual' },
    { label: 'Default values', code: 2, backendTypeCast: 'automatically_created_with_defaults' },
    { label: 'Autopricer', code: 3, backendTypeCast: 'auto_pricer_strategy' },
];
// The bot skips the article because the new price is too close to the current one: not a real
// pricing failure, the UI shows these under "Unchanged"
exports.PRICE_CHANGE_TOO_SMALL = 'article price did not change enough';
//# sourceMappingURL=constants.js.map